<template>
  <footer v-show="checkVisibility">
    <p>
      <span>iGuzzini &copy; {{getCurrentYear}}</span> |
      <a @click="trackExternalLink" :href="websiteUrl" title="iGuzzini" target="_blank"> {{websiteLabel}}</a> |
      <a @click="trackExternalLink" :href="contactsUrl" :title="capitalize(contactsLabel)" target="_blank"> {{contactsLabel}}</a> |
      <a @click="trackExternalLink" :href="termsUrl" :title="capitalize(termsLabel)" target="_blank"> {{termsLabel}}</a> |
      <a @click="trackExternalLink" :href="privacyUrl" :title="capitalize(privacyLabel)" target="_blank"> {{privacyLabel}}</a>
    </p>
  </footer>
</template>

<script>
  export default{
    data(){
      return{
        websiteUrl: '',
        websiteLabel: '',
        contactsUrl: '',
        contactsLabel: '',
        termsUrl: '',
        termsLabel: '',
        privacyUrl: '',
        privacyLabel: ''
      }
    },
    methods: {
      capitalize(string){
        var split = string.split(' ');
        for (var i = 0, len = split.length; i < len; i++) {
          split[i] = split[i].charAt(0).toUpperCase() + split[i].slice(1);
        }
        string= split.join(' ');
        return string;
      },
      trackExternalLink(e) {
        var href = e.target.getAttribute('href');

        eventTracking.send({
          category: 'ExternalLink',
          value: 'Click',
          label: href
        });

      }
    },
    computed: {
      getCurrentYear(){
        return new Date().getFullYear();
      },
      checkVisibility(){
        return this.$store.state.interface.isFooterVisible;
      }
    },
    mounted(){
      var vm = this;
      vm.websiteUrl = vm.$store.state.labels.footer.websiteUrl;
      vm.websiteLabel = vm.$store.state.labels.footer.websiteLabel;
      vm.contactsUrl = vm.$store.state.labels.footer.contactsUrl;
      vm.contactsLabel = vm.$store.state.labels.footer.contactsLabel;
      vm.termsUrl = vm.$store.state.labels.footer.termsUrl;
      vm.termsLabel = vm.$store.state.labels.footer.termsLabel;
      vm.privacyUrl = vm.$store.state.labels.footer.privacyUrl;
      vm.privacyLabel = vm.$store.state.labels.footer.privacyLabel;
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue